import formatNumber from 'support/formatters/formatNumber'

export default function formatCompactNumber (num, decimals = 0, min_decimals = 1, separatorMode = 'comma', numberSuffixes = []) {
  if (num === null) {
    return null
  }

  if (numberSuffixes.length === 0) {
    numberSuffixes.push('K', 'M', 'B', 'T')
  }

  if (!numberSuffixes || !Array.isArray(numberSuffixes)) {
    numberSuffixes = []
  }

  const suffixes = ['', ...numberSuffixes]

  let tier = Math.log10(Math.abs(num)) / 3 | 0
  let suffix = suffixes[tier]

  // Start shortening at 100k
  if (!suffix || tier === 0 || Math.abs(num) < 100000) {
    return formatNumber(num, decimals, min_decimals, separatorMode)
  }

  let scale = Math.pow(10, tier * 3)
  let scaled = num / scale

  if (scaled < 100) {
    tier -= 1
    scale = Math.pow(10, tier * 3)
    scaled = num / scale
    suffix = suffixes[tier]
  }

  scaled = formatNumber(scaled, scaled < 100 ? 1 : decimals, scale < 100 ? 1 : min_decimals, separatorMode)

  return scaled + suffix
}
